export var STATE_DELIMITER = '.';
export var EMPTY_ACTIVITY_MAP = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/xstate/es/constants.js
// module id = 777
// module chunks = 0